<!--
 * @Author: 月魂
 * @Date: 2021-06-07 16:45:46
 * @LastEditTime: 2021-07-04 17:07:35
 * @LastEditors: 月魂
 * @Description:
 * @FilePath: \nepal\src\components\nav.vue
-->
<template>
  <el-menu :default-active="active" mode="horizontal" @select="handleSelect">
    <el-menu-item v-for="(item, idx) in this.$t('menu')" :key="item.id" :index="'' + idx">{{ item.text }}</el-menu-item>
  </el-menu>
</template>

<script>

export default {
  name: 'Nav',
  data() {
    return {
      active: '0',
      list: ['/index', '/history', '/warriors']
    }
  },
  mounted() {
    const url = window.location.hash.split('#')[1]
    const index = this.list.findIndex(item => item === url)
    this.active = '' + index
  },
  methods: {
    handleSelect(key) {
      this.active = key
      this.$router.push(this.list[this.active])
    }
  }
}
</script>

<style lang="less" scoped>
</style>
